// extracted by mini-css-extract-plugin
export var avatar = "_om-3";
export var avatarContainer = "_om-2";
export var avatarSpacer = "_om-5";
export var avatarSpacerContainer = "_om-4";
export var avatarStackContainer = "_om-1";
export var bubble = "_om-0";
export var remainderBubble = "_om-6";